import { getDeviceInfo } from '@vmos2/core';
import type { Info } from '@vmos2/core';
import { useEffect, useState } from 'react';

export const useDeviceInfo = () => {
  const [deviceInfo, setDeviceInfo] = useState<Info>();
  const [isLoading, setIsLoading] = useState(true);
  const abortController = new AbortController();

  useEffect(() => {
    getDeviceInfo()
      .then(data => {
        if (abortController.signal.aborted) return;
        setDeviceInfo(data);
      })
      .finally(() => {
        if (abortController.signal.aborted) return;
        setIsLoading(false);
      });

      return () => abortController.abort('Component was unmounted');
  }, []);

  return { deviceInfo, isLoading };
};
